import React from 'react';

// شركاء موثوقين مأخوذين من البراندات الفعلية الموجودة في منتجات المتجر
const PARTNERS = [
  { name: 'Apple', category: 'إلكترونيات' },
  { name: 'Samsung', category: 'إلكترونيات' },
  { name: 'Nike', category: 'أزياء رياضية' },
  { name: 'Philips', category: 'أجهزة منزلية' },
  { name: 'Chanel', category: 'عطور وجمال' },
];

const TrustedPartners = () => {
  return (
    <section className="py-16 bg-[#F6F5F2]" dir="rtl">
      <div className="container mx-auto px-4">

        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 rounded-full bg-[#1B1B1F] text-[#F2B705] text-sm font-bold mb-3">
            شراكات موثوقة
          </span>

          <h2
            className="text-3xl md:text-4xl font-extrabold text-[#1B1B1F]"
            style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
          >
            وكلاؤنا المعتمدون
          </h2>

          <p className="text-gray-500 mt-3 max-w-xl mx-auto">
            نتعامل مباشرة مع أفضل العلامات التجارية العالمية لنضمن لك منتجات أصلية 100%
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {PARTNERS.map((partner) => (
            <div
              key={partner.name}
              className="group bg-white rounded-2xl p-6 flex flex-col items-center justify-center text-center shadow-[0_2px_10px_rgba(27,27,31,0.05)] hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <span
                className="text-2xl font-extrabold text-[#1B1B1F] group-hover:text-[#F2B705] transition-colors duration-300 mb-2"
                style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", letterSpacing: '0.02em' }}
              >
                {partner.name}
              </span>

              <span className="inline-flex items-center gap-1 text-xs font-bold text-[#F2B705] bg-[#1B1B1F] px-3 py-1 rounded-full">
                وكيل معتمد
              </span>

              <span className="text-xs text-gray-400 mt-2">{partner.category}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TrustedPartners;
